/* eslint-disable react/no-danger */
import Typography from '@common_typography';
import Button from '@common_button';
import TextField from '@common_forms/TextField';
import ReCAPTCHA from 'react-google-recaptcha';
import dynamic from 'next/dynamic';
import cx from 'classnames';
import { BREAKPOINTS } from '@theme_vars';
import { getStoreHost } from '@helpers/config';

const Message = dynamic(() => import('@common_toast'), { ssr: false });

const ContactForm = (props) => {
    const {
        //
        t,
        formik,
        sitekey,
        handleChangeCaptcha,
        recaptchaRef,
        message,
        setMessage,
        load,
        enableRecaptcha,
        isCms,
    } = props;

    const watchIcon = '/assets/img/watch.svg';

    return (
        <form
            onSubmit={formik.handleSubmit}
            className={cx(
                'contact-form relative tablet:min-w-[420px] tablet:ml-[98px] tablet:mt-[22px]',
                'bg-neutral-white mobile:max-tablet:p-5 px-[30px] py-[31px] w-[calc(100%-20px)] tablet:w-fit',
                'mobile:max-tablet:absolute mobile:max-tablet:left-1/2 mobile:max-tablet:-translate-x-1/2 mobile:max-tablet:mt-[-74px]',
            )}
        >
            <Message open={message.open} variant={message.variant} setOpen={() => setMessage({ ...message, open: false })} message={message.text} />
            {/* eslint-disable-next-line react/no-danger */}
            {!isCms ? (
                <Typography variant="h1" className="!text-2xl !font-semibold leading-[30px] mb-5">
                    {t('contact:contactUs')}
                </Typography>
            ) : null}

            <Typography variant="p3" className="!text-[15px] leading-[23px] font-medium mb-5 block">
                {t('contact:pleaseFillInForm')}
            </Typography>
            <TextField
                label={t('contact:fullName')}
                name="fullName"
                value={formik.values.fullName}
                onChange={formik.handleChange}
                hintProps={{
                    displayHintText: !!(formik.touched.fullName && formik.errors.fullName),
                    hintType: formik.touched.fullName && formik.errors.fullName ? 'error' : '',
                    hintText: (formik.touched.fullName && formik.errors.fullName) || null,
                }}
                classWrapper="mb-5"
                className="max-tablet:w-full w-full"
                absolute={false}
                required
            />
            <TextField
                label={t('contact:email')}
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                hintProps={{
                    displayHintText: !!(formik.touched.email && formik.errors.email),
                    hintType: formik.touched.email && formik.errors.email ? 'error' : '',
                    hintText: (formik.touched.email && formik.errors.email) || null,
                }}
                classWrapper="mb-5"
                className="max-tablet:w-full w-full"
                absolute={false}
                required
            />
            {/* <TextField
                label={t('contact:telephone')}
                name="telephone"
                value={formik.values.telephone}
                onChange={formik.handleChange}
                hintProps={{
                    displayHintText: !!(formik.touched.telephone && formik.errors.telephone),
                    hintType: formik.touched.telephone && formik.errors.telephone ? 'error' : '',
                    hintText: (formik.touched.telephone && formik.errors.telephone) || null,
                }}
                classWrapper="mb-5"
                className="max-tablet:w-full w-full"
                absolute={false}
                required
            /> */}
            <TextField
                label={t('contact:message')}
                name="message"
                multiline
                rows="4"
                value={formik.values.message}
                onChange={formik.handleChange}
                hintProps={{
                    displayHintText: !!(formik.touched.message && formik.errors.message),
                    hintType: formik.touched.message && formik.errors.message ? 'error' : '',
                    hintText: (formik.touched.message && formik.errors.message) || null,
                }}
                classWrapper="mb-5"
                className="max-tablet:w-full w-full"
                absolute={false}
                inputProps={{
                    cols: '5',
                    rows: '9',
                }}
                required
            />
            {enableRecaptcha ? (
                <>
                    <ReCAPTCHA sitekey={sitekey} onChange={handleChangeCaptcha} ref={recaptchaRef} />
                    {formik.touched.captcha && formik.errors.captcha && <Typography className="text-red">{formik.errors.captcha}</Typography>}
                </>
            ) : null}
            <div />
            <Button
                disabled={load}
                loading={load}
                align="left"
                type="submit"
                className={cx(
                    'flex justify-center uppercase rounded-none !leading-[26px] !font-bold !py-[11px] !font-sans',
                    '!bg-neutral-700 group hover:!bg-secondary-600 hover:shadow-none mt-[-1px] ',
                    'hover:border-secondary-600 w-full min-h-11 items-center',
                )}
                classNameText={cx(
                    '!font-medium !leading-[13px] !text-[12px] !tracking-[.33px] mobile:!text-neutral-white',
                )}
                variant="primary"
            >
                {t('contact:sendMessage')}
            </Button>
            <style jsx global>
                {`
                    .contact-btn-container {
                        margin-top: 50px;
                    }
                    .contact-form:before {
                        display: -webkit-flex;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-flex-wrap: wrap;
                        flex-wrap: wrap;
                        background: #f4d39d;
                        content: '';
                        position: absolute;
                        width: 103%;
                        height: 100%;
                        z-index: -1;
                        top: 36px;
                        left: -35px;
                        transform: rotate(355deg);
                    }
                    .contact-form:after {
                        background: url(${watchIcon}) center no-repeat;
                        display: block;
                        content: '';
                        position: absolute;
                        background-size: contain;
                        width: 57px;
                        height: 100px;
                        right: -5px;
                        top: -41px;
                    }
                    @media only screen and (min-width: ${BREAKPOINTS.md}px) {
                        .contact-form:after {
                            width: 80px;
                            height: 140px;
                            right: -40px;
                            top: -50px;
                        }
                    }
                    @media only screen and (max-width: 767px) {
                        .contact-form:before {
                            display: none;
                        }
                    }
                `}
            </style>
        </form>
    );
};

// eslint-disable-next-line arrow-body-style
const ContactPage = (props) => {
    // const {
    //     //
    //     data,
    //     loading,
    //     Skeleton,
    //     isCms,
    // } = props;

    return (
        <div className="contact-container relative">
            <div className="flex flex-row flex-wrap tablet:flex-nowrap  min-h-[634px] max-w-[1100px] mx-auto">
                <div className="md:basis-1/2 xs:basis-full max-tablet:mt-4 tablet:px-8">
                    <ContactForm {...props} />
                </div>
                {/* {!isCms ? (
                    <div className="md:basis-1/2 xs:basis-full">
                        {!loading && <div dangerouslySetInnerHTML={{ __html: data?.cmsBlocks?.items[0]?.content }} />}
                        {loading && <Skeleton />}
                    </div>
                ) : null} */}

            </div>
            <style jsx global>
                {`
                    :root {
                        --image-url-contact: url('${getStoreHost()}media/wysiwyg/contact-us.png');
                        --image-url-contact-mobile: url('${getStoreHost()}/media/wysiwyg/contact-us-mobile.png');
                    }
                    main {
                        max-width: 100% !important;
                        padding: 0 !important;
                    }
                    .contact-container:before {
                        background: var(--image-url-contact-mobile) center no-repeat;
                        content: '';
                        display: flex;
                        flex-wrap: wrap;
                        width: 100%;
                        height: 215px;
                        background-size: cover;
                    }
                    @media only screen and (min-width: ${BREAKPOINTS.md}px) {
                        .contact-container:before {
                            background: var(--image-url-contact) center no-repeat;
                            width: 92%;
                            height: 76%;
                            background-position: right 0;
                            position: absolute;
                            z-index: -1;
                            top: -8px;
                            right: 0;
                            background-size: cover;
                        }
                    }
                    @media only screen and (max-width: 767px) {
                        main {
                            margin-top: 6px !important;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default ContactPage;
